import React from 'react';
import { TimelineSection } from '@/types';
import TimelineSidebarEntry from './TimelineSidebarEntry';
import TimelineSidebarChat from './TimelineSidebarChat';

interface TimelineChatSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  onMemoryCreated?: (sectionId: string) => void;
  className?: string;
  targetUserId?: string;
  targetUserProfile?: any;
  timelineSections?: TimelineSection[];
  sectionsLoading?: boolean;
  timelineError?: boolean;
  mode?: 'create' | 'view';
  viewEntryId?: string;
  preselectedSectionId?: string;
}

const TimelineChatSidebar = (props: TimelineChatSidebarProps) => {
  const { mode = 'create' } = props;

  if (mode === 'view') {
    return (
      <TimelineSidebarEntry
        isOpen={props.isOpen}
        onClose={props.onClose}
        className={props.className}
        targetUserProfile={props.targetUserProfile}
        viewEntryId={props.viewEntryId}
      />
    );
  }

  return (
    <TimelineSidebarChat
      isOpen={props.isOpen}
      onClose={props.onClose}
      onMemoryCreated={props.onMemoryCreated}
      className={props.className}
      targetUserId={props.targetUserId}
      targetUserProfile={props.targetUserProfile}
      timelineSections={props.timelineSections}
      sectionsLoading={props.sectionsLoading}
      timelineError={props.timelineError}
      preselectedSectionId={props.preselectedSectionId}
    />
  );
};

export default TimelineChatSidebar;